"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalizeFactory = exports.externalizeProcessedFactory = exports.externalizeFactory = exports.processFactory = void 0;
const abortable_fetch_1 = require("../../../../utils/abortable-fetch");
function processFactory(url) {
    return function send() {
        return abortable_fetch_1.abortableFetch(`${url}/process`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.processFactory = processFactory;
function externalizeFactory(api) {
    return function externalize(id) {
        return abortable_fetch_1.abortableFetch(`${api}/${id}/externalize`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.externalizeFactory = externalizeFactory;
function externalizeProcessedFactory(url) {
    return function externalizeProcessed() {
        return abortable_fetch_1.abortableFetch(`${url}/externalize-processed`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.externalizeProcessedFactory = externalizeProcessedFactory;
function internalizeFactory(api) {
    return function internalize(id) {
        return abortable_fetch_1.abortableFetch(`${api}/${id}/internalize`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            method: 'POST',
        });
    };
}
exports.internalizeFactory = internalizeFactory;
//# sourceMappingURL=batches-api.js.map